module.exports = __webpack_public_path__ + "static/img/hm_loop_card_03.ce673de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthMonitoring/hm_loop_card_03.png
// module id = 8O07
// module chunks = 1